import { Box, Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BackArrow from '@mui/icons-material/ArrowBackIosNew';
import NextArrow from '@mui/icons-material/ArrowForwardIos';
import {
  ForwardedRef,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { baseUrl } from '../customDataProvider';

const getAccessToken = () => localStorage.getItem('accessToken') || '';

interface ImageGalleryModalProps {
  images: any[];
  imageDefaultIndex?: number;
  openModal: boolean;
  setOpenModal: (val: boolean) => void;
  children: React.ReactNode;
}

export const ImageGalleryModal = forwardRef(function ImageGalleryModal(
  props: ImageGalleryModalProps,
  ref: ForwardedRef<unknown>,
) {
  const { images, imageDefaultIndex = 0, setOpenModal, openModal, children } = props;
  const [index, setIndex] = useState(imageDefaultIndex);
  const [imageDataUrl, setImageDataUrl] = useState('');

  useImperativeHandle(
    ref,
    () => ({
      handleOpenModal(indexParam: number = 0) {
        setOpenModal(true);
        setIndex(indexParam);
      },
    }),
    [],
  );

  const handleNext = () => {
    setIndex((index + 1) % images.length);
    setImageDataUrl('');
  };
  const handlePrev = () => {
    setIndex((index - 1 + images.length) % images.length);
    setImageDataUrl('');
  };
  const handleCloseModal = () => setOpenModal(false);

  const getBase64Image = async (res: any) => {
    const blob = await res.blob();
    const reader = new FileReader();

    await new Promise((resolve, reject) => {
      reader.onload = resolve;
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    return reader.result;
  };

  useEffect(() => {
    if (images[index]) {
      fetch(`${baseUrl}/files/${images[index].id}/content`, {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      })
        .then(getBase64Image)
        .then((imgString) => setImageDataUrl(imgString as string));
    }
  }, [index]);

  if (!images || !images.length || !images[index]) return null;

  return (
    <>
      {children}
      <Dialog open={openModal} onClose={handleCloseModal} fullScreen={true}>
        <IconButton
          aria-label="close"
          onClick={handleCloseModal}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          sx={{
            backgroundColor: 'black',
            alignContent: 'center',
            textAlign: 'center',
          }}
        >
          <Box alignItems="center" display="flex">
            {images.length > 1 && (
              <Box bgcolor="#FFF" borderRadius={100} p={1} sx={{ '&:hover': { cursor: 'pointer' } }}>
                <BackArrow onClick={handlePrev} />
              </Box>
            )}
            <Box flex={1}>
              {imageDataUrl.length === 0 ? (
                <Box
                  sx={{
                    display: 'inline-block',
                    marginRight: '10px',
                    width: '111px',
                    height: '111px',
                    backgroundImage: `url(data:${images[index].mimeType};base64,${images[index].thumbnail})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    borderRadius: '1em',
                    '&:hover': {
                      cursor: 'pointer',
                    },
                  }}
                />
              ) : (
                <img
                  src={imageDataUrl}
                  style={{ maxWidth: '100%', maxHeight: 'calc(100vh - 64px)' }}
                  alt="image"
                />
              )}
            </Box>
            {images.length > 1 && (
              <Box bgcolor="#FFF" borderRadius={100} p={1} sx={{ '&:hover': { cursor: 'pointer' } }}>
                <NextArrow onClick={handleNext} />
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
});


